import React, { createContext, useCallback, useEffect, useState } from "react";
import { fetchWithAuth } from "../utils/auth";

export const CategoriasContext = createContext();

export function CategoriasProvider({ children }) {
  const [categorias, setCategorias] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

  const carregarCategorias = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/categorias`);
      const data = await res.json();
      setCategorias(data);
    } catch (err) {
      console.error("Erro ao buscar categorias:", err);
    }
  }, [API_URL]);

  useEffect(() => {
    carregarCategorias();
  }, [carregarCategorias]);

  const criarCategoria = useCallback(async (nome_categoria) => {
    const res = await fetchWithAuth(`${API_URL}/categorias`, {
      method: "POST",
      body: JSON.stringify({ nome_categoria }),
    });

    if (!res) return null;

    if (!res.ok) {
      const erro = await res.json().catch(() => ({}));
      throw new Error(erro.error || "Erro ao criar seção");
    }

    const novaCategoria = await res.json();
    setCategorias((atual) => [...atual, novaCategoria]);
    return novaCategoria;
  }, [API_URL]);

  return (
    <CategoriasContext.Provider value={{ categorias, criarCategoria, carregarCategorias }}>
      {children}
    </CategoriasContext.Provider>
  );
}
